import { atom } from 'recoil';

const storeList = atom<Array<{ id: string; name: string }>>({
  key: 'storeList',
  default: [],
});

export default storeList;
